import { render, staticRenderFns } from "./AddSequenceToGradualMessage.vue?vue&type=template&id=16b0623e&"
import script from "./AddSequenceToGradualMessage.vue?vue&type=script&lang=js&"
export * from "./AddSequenceToGradualMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports